import axios from 'axios';
import { toast } from 'react-toastify';

// Create axios instance
const api = axios.create({
  baseURL: '/backend',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // If token exists, add to headers
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;
    
    // Handle different error statuses
    if (response) {
      switch (response.status) {
        case 401:
          // Unauthorized - clear token and redirect to login
          localStorage.removeItem('token');
          window.location.href = '/login';
          toast.error('Session expired. Please log in again.');
          break;
          
        case 403:
          // Forbidden
          toast.error('You do not have permission to perform this action.');
          break;
          
        case 404:
          // Not found
          toast.error(response.data?.error || response.data?.message || 'Resource not found.');
          break;
          
        case 500:
          // Server error
          toast.error(response.data?.error || response.data?.message || 'Server error. Please try again later.');
          break;
          
        default:
          // Other errors
          const errorMessage = response.data?.error || response.data?.message || 'An error occurred';
          toast.error(errorMessage);
      }
    } else {
      // Network error
      toast.error('Network error. Please check your connection.');
    }
    
    return Promise.reject(error);
  }
);

export default api;
